import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// create react root
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
